import { Card, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { ReactComponent as CheckMark } from "../../images/checkMark.svg";
import styles from "./steps.module.css";
import { WhiteBoxBlock } from "ui/WhiteBoxBlock";
import { CardSteps } from "components";
import { StepItem } from "pages/BidInfoPage/BidSteps/_utils";
import { CustomEmpty } from "ui/CustomEmpty";

interface ContractCardStepsProps {
  currentIndex: number;
  items: {
    title: "Создание заявки" | "Оплата" | "Исполнение";
    items: StepItem[];
  }[];
}

enum BlockType {
  First = 0,
  Payment = 1,
  Completed = 2,
}

const getStepNumberClassName = (index: number, currentIndex: number) => {
  if (index === currentIndex) {
    return styles.stepNumberCurrent;
  }

  if (index < currentIndex) {
    return styles.stepNumberPast;
  }

  return styles.stepNumberFuture;
};

export const Steps = observer(({ currentIndex, items }: ContractCardStepsProps) => {
  const isPaymentBlock = currentIndex === BlockType.Payment;
  const isCompletedBlock = currentIndex === BlockType.Completed;
  return (
    <Card bordered={false}>
      <Flex vertical className="padding-none">
        {items.map((item, index) => (
          <WhiteBoxBlock
            key={index}
            collapse={{
              title: (
                <Flex key={index} gap="middle" align="flex-start" className={styles.stepItem}>
                  <Flex>
                    <Typography.Text
                      strong
                      className={`${styles.stepNumber} ${getStepNumberClassName(index, currentIndex)}`}
                    >
                      {index < currentIndex ? <CheckMark /> : index + 1}
                    </Typography.Text>
                  </Flex>
                  <Flex vertical gap="small" className="flex-grow">
                    <Typography.Text strong className={index === currentIndex ? "text-primary" : ""}>
                      {item.title}
                    </Typography.Text>
                  </Flex>
                </Flex>
              ),
              defaultOpen: currentIndex === index,
              className: styles.stepWrapper,
            }}
          >
            {item.items.length ? (
              <CardSteps items={item.items} currentIndex={currentIndex} />
            ) : (
              <CustomEmpty
                description={
                  isPaymentBlock
                    ? "Действий по оплате не найдено"
                    : isCompletedBlock
                      ? "Заявка не переходила в статус исполнения"
                      : "Нет данных"
                }
              />
            )}
          </WhiteBoxBlock>
        ))}
      </Flex>
    </Card>
  );
});
